import React from 'react'
import Price from '../models/Price'
import { Tax } from '../models/Tax'
import { BoxAddLess } from './BoxAddLess'
import { Vis } from 'models/Vis'
import {calculatePrecioViaje, isMaxToReserveReached} from '../Modules/Stretch/priceUtils'

interface Props {
  precio: Price
  index: number
  tax: Tax
  visitas: Vis
  money: any
  isCollaboratorStretch?: boolean
  minimumPassengerReach?: any
  quitarVisitantePrices(event: any): void
  addVisitantePrices(event: any): void
  t: (key: string) => string
}

export const PriceItem = (
  {
    precio,
    index,
    tax,
    visitas,
    money,
    isCollaboratorStretch,
    minimumPassengerReach,
    quitarVisitantePrices,
    addVisitantePrices,
    t,
  }: Props) => {
  
  const category = precio.passengerCategory
  if (!category || precio.price <= 0) return null

  const indexCategory = visitas.names.indexOf(category.name)
  const passengersInCategory = visitas.vis[indexCategory]

  // Colaborador sin precio neto
  if (isCollaboratorStretch && (!precio.priceNet || precio.priceNet <= 0)) {
    return null
  }

  const precioViaje = calculatePrecioViaje(precio, tax)
  const maxToReserveReach = isMaxToReserveReached(passengersInCategory, category.maxToReserve)

  return (
    <div className="opciones" key={precio.id}>
      <BoxAddLess
        name={category.name}
        priceUnitary={precioViaje}
        prices={visitas.price}
        disabled={visitas.vis[index] === 0}
        quantities={visitas.vis}
        description={category.description}
        money={money}
        index={index}
        minimum={category.minToReserve}
        minimumPassengerReach={minimumPassengerReach}
        substract={quitarVisitantePrices}
        add={addVisitantePrices}
        t={t}
        maxToReserveReach={maxToReserveReach}
      />
    </div>
  )
}
